// For /verificationV2 to define general register / ibt register
export default Object.freeze({
  general: 1,
  ibt: 2,
})
